import { render, staticRenderFns } from "./direct-debit-files.vue?vue&type=template&id=2ccbb247&"
import script from "./direct-debit-files.ts?vue&type=script&lang=ts&"
export * from "./direct-debit-files.ts?vue&type=script&lang=ts&"
import style0 from "./direct-debit-files.scss?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports